let baseURL = process.env.VUE_APP_BASE_URL;

export default baseURL;
